import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faSpinner, faExclamationTriangle, faUser } from "@fortawesome/pro-solid-svg-icons";
export const UserCreationStep = ({ isMonitoring, monitoringError, createdUsers, successfullyCreatedCount, hasWarnings, jobStatus, currentStep, rowClassName, }) => {
    const getIcon = () => {
        if (currentStep === "job-monitoring" && isMonitoring) {
            return _jsx(FontAwesomeIcon, { icon: faSpinner, spin: true });
        }
        if (monitoringError && createdUsers.length === 0) {
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle });
        }
        if (successfullyCreatedCount === 0 && hasWarnings) {
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle });
        }
        if (hasWarnings) {
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle });
        }
        if (successfullyCreatedCount > 0) {
            return _jsx(FontAwesomeIcon, { icon: faCheckCircle });
        }
        return _jsx(FontAwesomeIcon, { icon: faUser });
    };
    const getStatusText = () => {
        if (successfullyCreatedCount === 0 && hasWarnings) {
            return " - see warnings below";
        }
        if (hasWarnings) {
            return ` (${createdUsers.length - successfullyCreatedCount} with warnings)`;
        }
        return "";
    };
    const getRightContent = () => {
        if (currentStep === "job-monitoring" && isMonitoring) {
            return _jsxs("span", { children: ["Processing... ", jobStatus || "Pending"] });
        }
        if (monitoringError && createdUsers.length === 0) {
            return _jsx("span", { children: monitoringError });
        }
        if (createdUsers.length > 0) {
            return (_jsxs(_Fragment, { children: [_jsxs("span", { children: [successfullyCreatedCount, " created", getStatusText()] }), createdUsers.map((user, idx) => (_jsx("span", { className: `auto-provisioning__user-badge ${user.status === "Warn" || user.status === "Error" ? "warning" : ""}`, children: user.displayName }, idx)))] }));
        }
        return null;
    };
    const isActivelyMonitoring = currentStep === "job-monitoring" && isMonitoring;
    return (_jsxs("div", { className: `auto-provisioning__workflow-row ${rowClassName}`, children: [_jsxs("div", { className: "auto-provisioning__row-left", children: [getIcon(), _jsx("span", { className: "auto-provisioning__row-label", children: "User Creation" })] }), _jsx("div", { className: "auto-provisioning__row-right", children: getRightContent() }), isActivelyMonitoring && (_jsx("div", { className: "auto-provisioning__monitoring-note", children: "Note: this process is asynchronous and runs every 5 minutes. It is expected that you may sit on this step for a little while." }))] }));
};
